import script from "./OkrChartWithTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrChartWithTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./OkrChartWithTableLoader.vue?vue&type=style&index=0&id=2a73d56d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a73d56d"]])

export default __exports__